import React, { useState, useEffect } from "react";

import HandShakeIcon from "@src/assets/icons/handshake.svg";
import { JointVentureChangeModal } from "@src/features/role_request_details/components/joint_venture_change_modal";
import { RoleRequest } from "@src/types/role_request_types";
import { Checkbox, CheckboxChangeEvent } from "antd";
import "./joint_venture_checkbox.less";

interface JointVentureCheckboxProps {
  request: RoleRequest;
}

const JointVentureCheckbox: React.FC<JointVentureCheckboxProps> = ({
  request,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isJointVentureModalOpen, setIsJointVentureModalOpen] =
    useState<boolean>(false);

  useEffect(() => {
    setIsChecked(request.jointVenture);
  }, [request?.jointVenture]);

  /**
   * Handle the checkbox change event.
   * - When the request is a draft, then the flag will be saved into the store and saved when the user clicks the
   * apply changes button. It is necessary to do it because the user may also change other fields like the additional information.
   *
   * - When the request is not a draft, then the change joint venture confirmation modal will open
   *
   * @param changeEvent is the checkbox event wihch one will be prevented from the default
   * behaviour so that it will only be checked when the modal was accepted
   */
  function handleCheckboxChange(changeEvent: CheckboxChangeEvent) {
    changeEvent.preventDefault();
    setIsJointVentureModalOpen(true);
  }

  return (
    <div className="joint-venture-checkbox">
      {isJointVentureModalOpen && (
        <JointVentureChangeModal
          showModal={isJointVentureModalOpen}
          setShowModal={(isModalOpen: boolean) =>
            setIsJointVentureModalOpen(isModalOpen)
          }
          request={request}
        />
      )}
      <Checkbox checked={isChecked} onChange={handleCheckboxChange}>
        <span
          className="joint-venture-checkbox__label"
          data-testid="joint-venture-checkbox-label"
        >
          Joint Venture{" "}
          <HandShakeIcon role="icon" data-testid="handshake-icon" />
        </span>
      </Checkbox>
    </div>
  );
};

export default JointVentureCheckbox;
